import { EntityName } from '../../../auth/Security';

export function resolveEntityDeepLinkUIStatePath(
    entity: EntityName,
    entityDeepLinkUIStatePath?: string,
    entityDeepLinkBaseUIStatePath?: string
): string {
    if (entityDeepLinkUIStatePath) {
        return entityDeepLinkUIStatePath;
    }

    const entityNamePathFragment = entity.toLowerCase();

    let resolvedDeepLinkUIStatePath = entityNamePathFragment;

    if (entityDeepLinkBaseUIStatePath) {
        resolvedDeepLinkUIStatePath = `${entityDeepLinkBaseUIStatePath}.${entityNamePathFragment}`;
    }

    return resolvedDeepLinkUIStatePath;
}
